<template>
  <v-main>
    <!-- TOP IMAGE -->
    <v-container
      class="col-10 pa-0 ma-0-auto mt-4 d-flex flex-column flex-lg-row page-wrapper mb-16"
    >
      <v-img src="@/assets/images/entrypages/7_MOSTMICRO.jpg" height="250">
        <div style="margin-top: 30px; margin-left: 30px;">
          <h4 class="page-title">
            <span
              style="background-color: white ; opacity: 0.9; padding: 10px;"
            >
              {{ $t(menu).content.title }}</span
            >
          </h4>
        </div>
      </v-img>
    </v-container>

    <!-- Bellow the image intro -->

    <v-container
      class="col-10 pa-0 ma-0-auto d-flex flex-column flex-lg-row page-wrapper"
    >
      <!-- SIDE MENU -->
      <div class="col-12 col-lg-3 pa-0 page-sidebar">
        <SideMenu
          class="d-none d-lg-block"
          page="/academics/"
          :menu="menu"
          @menuContent="passMenuContent"
        ></SideMenu>
      </div>
      <!-- CONTENT -->

      <div class="col-12 col-lg-9 pa-0 pl-lg-12 page-content">
        <Blues v-if="this.$route.params.slug === 'blues'" :content="content" />
        <Challenges
          v-else-if="this.$route.params.slug === 'challenges'"
          :content="content"
        />
        <Sciencepreneur
          v-else-if="this.$route.params.slug === 'sciencepreneur'"
          :content="content"
        />
        <SpinoffApplication
          v-else-if="this.$route.params.slug === 'spinoff-application'"
          :content="content"
        />
        <SpinoffList
          v-else-if="this.$route.params.slug === 'spinoff-list'"
          :content="content"
        />

        <Startacompany
          v-else-if="this.$route.params.slug === 'startacompany'"
          :content="content"
        />
        <PluggedInNova
          v-else-if="this.$route.params.slug === 'plugged-in-nova'"
          :content="content"
        />

        <Starters
          v-else-if="this.$route.params.slug === 'starters'"
          :content="content"
        />

        <TellUsYourIdea
          v-else-if="this.$route.params.slug === 'tell-us-your-idea'"
          :content="content"
        />
        <IntellectualProperty
          v-else-if="this.$route.params.slug === 'intellectual-property'"
          :content="content"
        />
        <TheProcess
          v-else-if="this.$route.params.slug === 'the-process'"
          :content="content"
        />
        <DiscloseProtectYourIP
          v-else-if="this.$route.params.slug === 'disclose-protect-your-ip'"
          :content="content"
        />
        <IntellectualPropertyPolicy
          v-else-if="this.$route.params.slug === 'intellectual-policy'"
          :content="content"
        />

        <UsefulLinks
          v-else-if="this.$route.params.slug === 'useful-links'"
          :content="content"
        />
        <IndustryCalls
          v-else-if="this.$route.params.slug === 'industry-calls'"
          :content="content"
        />
        <div v-else-if="this.$route.fullPath.endsWith('academics')">
          <Home :content="$t(menu).content" />
          <div>
            <SideMenu
              class="d-lg-none mt-10"
              page="/academics/"
              :menu="menu"
              @menuContent="passMenuContent"
            ></SideMenu>
          </div>
        </div>

        <NotFound v-else :menu="menu" />
      </div>
    </v-container>
  </v-main>
</template>

<script>
import SideMenu from '@/components/SideMenu'
import Home from './Academics/Home'
import Blues from './Academics/Blues'
import Challenges from './Academics/Challenges'
import Sciencepreneur from './Academics/Sciencepreneur'
import SpinoffApplication from './Academics/SpinoffApplication'
import SpinoffList from './Academics/SpinoffList'
import Startacompany from './Academics/Startacompany'
import PluggedInNova from './Academics/PluggedInNova'
import Starters from './Academics/Starters'
import TellUsYourIdea from './Academics/TellUsYourIdea'
import IntellectualProperty from './Academics/IntellectualProperty'
import TheProcess from './Academics/TheProcess'
import DiscloseProtectYourIP from './Academics/DiscloseProtectYourIP'
import IntellectualPropertyPolicy from './Academics/IntellectualPropertyPolicy'
import UsefulLinks from './Academics/UsefulLinks'
import IndustryCalls from './Academics/IndustryCalls'
import NotFound from './NotFound'

export default {
  name: 'Academics',
  components: {
    SideMenu,
    Home,
    Blues,
    Challenges,
    Sciencepreneur,
    SpinoffApplication,
    SpinoffList,
    Startacompany,
    PluggedInNova,
    Starters,
    TellUsYourIdea,
    IntellectualProperty,
    TheProcess,
    DiscloseProtectYourIP,
    IntellectualPropertyPolicy,
    UsefulLinks,
    IndustryCalls,
    NotFound,
  },
  data() {
    return {
      search: null,
      caseSensitive: false,
      menu: 'SideMenuAcademics',
      content: {},
    }
  },
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    },
  },
  methods: {
    passMenuContent(content) {
      this.content = content
    },
  },
}
</script>

<style lang="scss">
.academics-page {
  h2 {
    @extend .content-title;
  }

  .academics-text {
    @extend .content-body;
  }

  .v-expansion-panels {
    border: 1px solid #878a8c !important;
  }
}

.page-title {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 20px !important;
  }
}
</style>
